// @flow
'use strict'

const wixDataFunctions = ['save', 'remove', 'find', 'filter', 'query']
const wixDataSchemasFunctions = ['list', 'bulkGet']

/*::
import typeof { WixDataApi } from 'wix-data-core'
import typeof { WixDataSchemaApi } from 'wix-data-schema-api'

export type WixDataCreator = () => { wixData: WixDataApi, wixDataSchemas: WixDataSchemaApi }

type ObjectWrapper<A: $ReadOnly<{ [string]: Function }>> = ($ReadOnly<{ [string]: Function }>, Array<$Keys<A>>, Function) => A
*/

const objectWrapper /*: Function */ = (
  sourceObj,
  functionsToWrap,
  wrapperFn
) => {
  const wrappedObj = Object.assign({}, sourceObj)
  functionsToWrap.forEach(fName => {
    wrappedObj[fName] = wrapperFn((...args) => sourceObj[fName](...args))
  })
  return wrappedObj
}

const wixDataFunctionWrapper /*: ObjectWrapper<WixDataApi> */ = objectWrapper
const wixDataSchemaFunctionWrapper /*: ObjectWrapper<WixDataSchemaApi> */ = objectWrapper

module.exports = (
  wixDataCodeZone /*: Function => Function */,
  wixDataCreator /*: WixDataCreator */
) => {
  const { wixData, wixDataSchemas } = wixDataCreator()

  return {
    wixDataProxy: wixDataFunctionWrapper(
      wixData,
      wixDataFunctions,
      wixDataCodeZone
    ),
    wixDataSchemasProxy: wixDataSchemaFunctionWrapper(
      wixDataSchemas,
      wixDataSchemasFunctions,
      wixDataCodeZone
    )
  }
}



// WEBPACK FOOTER //
// ./wix-data/wixDataProxy.js